/**
 * PlanningActions.js — Routeur de vues du module Planning d'Actions
 * Design System SEIZO
 *
 * C'est le SEUL composant qui porte contentNiv1 + SidebarWidgets.
 * Les vues enfants (Kanban, VueCalendaire, VueTableau, Parametrage)
 * ne doivent PAS inclure de layout wrapper.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { useStores } from '../../../stores/Context';
import SidebarWidgets from '../../SidebarWidgets/SidebarWidgets';
import Kanban from './Kanban';
import Parametrage from './Parametrage';
import VueCalendaire from './VueCalendaire';
import VueTableau from './VueTableau';
import TacheForm from './Overlay/TacheForm';
import Archive from './Overlay/Archive';
import IntertotemActions from './Overlay/IntertotemActions';

// ── Table de routage des vues ─────────────────────────────────────────────────
const ViewComponents = {
    'Lecture':                          Kanban,
    'Kanban':                           Kanban,
    'Paramétrage':                      Parametrage,
    'Paramétrage colonnes / lignes':    Parametrage,
    'Calendrier':                       VueCalendaire,
    'Jour':                             VueCalendaire,
    'Semaine':                          VueCalendaire,
    'Mois':                             VueCalendaire,
    'Tableau':                          VueTableau,
};

const PlanningActions = observer(() => {
    const { PlanningActionsStore, widgetStore, sidebarWidgetStore } = useStores();

    const MyView = ViewComponents[PlanningActionsStore.view] || null;

    if (PlanningActionsStore.isLoading) {
        return (
            <div className={`contentNiv1${sidebarWidgetStore.openSidebarWidget ? ' contentNiv1--sidebarOpen' : ''}`}>
                <SidebarWidgets widget="PlanningActions" />
                <div style={{
                    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    gap: 10, color: '#70787B', fontFamily: 'Nunito, sans-serif'
                }}>
                    <span style={{
                        width: 18, height: 18, border: '2px solid #DBE3E7',
                        borderTopColor: '#00B0FF', borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite', display: 'inline-block'
                    }} />
                    Chargement…
                </div>
            </div>
        );
    }

    if (PlanningActionsStore.planningNotFound) {
        widgetStore.removeWidgetAvailable(PlanningActionsStore.idWidget);
        return (
            <div className={`contentNiv1${sidebarWidgetStore.openSidebarWidget ? ' contentNiv1--sidebarOpen' : ''}`}>
                <SidebarWidgets widget="PlanningActions" />
                <div style={{
                    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#70787B', fontFamily: 'Nunito, sans-serif', fontSize: 14
                }}>
                    Ce planning n'existe plus
                </div>
            </div>
        );
    }

    const viewModalFormAction = PlanningActionsStore.viewModalFormAction;
    const viewModal            = PlanningActionsStore.viewModal;

    return (
        <div className={`contentNiv1${sidebarWidgetStore.openSidebarWidget ? ' contentNiv1--sidebarOpen' : ''}`}>
            <SidebarWidgets widget="PlanningActions" />
            {MyView ? <MyView /> : null}

            {/* Tiroir TacheForm rendu via Portal hors du contentNiv1 (overflow:auto crée un stacking context) */}
            {viewModalFormAction != null && ReactDOM.createPortal(
                <TacheForm />,
                document.body
            )}

            {/* Point d'entrée unique des actions reçues et envoyées entre Totems */}
            {viewModal === 'intertotem actions' && ReactDOM.createPortal(
                <IntertotemActions />,
                document.body
            )}

            {/* Tiroir Archives */}
            {viewModal === 'archive' && ReactDOM.createPortal(
                <Archive />,
                document.body
            )}
        </div>
    );
});

export default PlanningActions;
